export default "__VITE_ASSET__Bx1i9hqr__"